// extracted by css-extract-rspack-plugin
export default {"group":"group-Czjo7h","spaced":"spaced-vk1ibS","attached":"attached-cFOtLx"};